var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCodeError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.38,
    height: 16.556,
    viewBox: "0 0 17.38 16.556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_1",
    "data-name": "Uni\\xE3o 1",
    d: "M11.071,12.866,8.485,15.557,6.762,13.763l2.586-2.692L6.762,8.38,8.485,6.585l2.586,2.692,2.586-2.692L15.38,8.38l-2.586,2.691,2.586,2.692-1.724,1.794ZM-2,15V9.667H3.334V15Zm1.333-1.334H2V11H-.667ZM0,13V11.667H1.333V13ZM3.334,8.778V7H1.555V5.222H5.111V8.778Zm-3.556,0V7H-2V5.222H-.222V7H1.555V8.778ZM8.667,4.333V-1H14V4.333ZM10,3h2.667V.333H10ZM4.222,4.333V.778H6V2.555H7.778V4.333ZM-2,4.333V-1H3.334V4.333ZM-.667,3H2V.333H-.667Zm11.334-.666V1H12V2.334ZM0,2.334V1H1.333V2.334ZM6,.778V-1H7.778V.778Z",
    transform: "translate(2 1)",
    fill: "#22638d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeError);
export default __webpack_public_path__ + "static/media/qrCodeError.10addbd1c2510dbb30fee27cfb48a5c3.svg";
export { ForwardRef as ReactComponent };